/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./demand-info.vue?vue&type=template&id=73d376fc&"
import script from "./demand-info.vue?vue&type=script&lang=js&"
export * from "./demand-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports